import api from '@/sui/api/api'

let module = null

const remote = true
if (remote) {
  module = {
    resetPassword (prefix, id, email, password) {
      const request = {
        i: id,
        e: email,
        p: password
      }
      return api.post(`${prefix}/resetpassword`, request)
    },

    initPassword (prefix, name, firstName, email, forgot) {
      const request = {
        n: name,
        f: firstName,
        e: email,
        b: forgot
      }
      return api.post(`${prefix}/initpassword`, request)
    }
  }
}

export default module
